import type { ChargebeeCredentials, ChargebeeSdk } from '../interfaces/chargebee.interface';
import {
  CHARGEBEE_API_DOMAIN,
  CHARGEBEE_ORIGIN,
  CHARGEBEE_SCRIPT_SRC,
  PAYMENT_SCRIPT_TIMEOUT_MS,
  STRIPE_API_ORIGIN,
} from '../common/constants/paymentInit';
import { dropScript, loadScript, preconnect } from './paymentScripts';

const globalScope = globalThis as { Chargebee?: ChargebeeSdk };

let isUnusable = false;

export function chargebeeSdk(): ChargebeeSdk {
  const sdk = globalScope.Chargebee;

  if (!sdk) throw new Error('Chargebee script loaded without installing its global');

  return sdk;
}

export function dropUnusableChargebeeSdk(): void {
  if (!isUnusable) return;

  isUnusable = false;
  globalScope.Chargebee?.tearDown();
  delete globalScope.Chargebee;
  dropScript(CHARGEBEE_SCRIPT_SRC);
}

export async function startChargebeeSdk(
  credentials: ChargebeeCredentials,
  isCurrent: () => boolean,
): Promise<void> {
  preconnect(CHARGEBEE_ORIGIN);
  preconnect(`https://${credentials.site}.${CHARGEBEE_API_DOMAIN}`, true);
  preconnect(STRIPE_API_ORIGIN, true);

  await loadScript(CHARGEBEE_SCRIPT_SRC, PAYMENT_SCRIPT_TIMEOUT_MS);

  if (!isCurrent()) return;

  isUnusable = true;
  try {
    const sdk = chargebeeSdk();

    sdk.init(credentials);

    await sdk.getInstance().load('components');
  } catch (error) {
    isUnusable = true;
    throw error;
  }

  if (!isCurrent()) return;

  isUnusable = false;
}
